import React from "react";
import "./Services.css";

export const servicesData = [
  {
    id: "event-planning",
    title: "Event Planning & Coordination",
    description:
      "Complete event planning and coordination from concept to execution, ensuring smooth delivery and attention to detail.",
  },
  {
    id: "stage-design",
    title: "Stage Design & Event Production",
    description:
      "Custom stage concepts and professional event production that elevate the visual experience and atmosphere.",
  },
  {
    id: "themes",
    title: "Custom Event Themes",
    description:
      "Creative event themes and tailored concepts designed to match your vision, style, and brand identity.",
  },
  {
    id: "backdrops",
    title: "Backdrops & Venue Styling",
    description:
      "Elegant decorative solutions, wallpapers, and statement backdrops that transform venues beautifully.",
  },
  {
    id: "branding",
    title: "Branding & Visual Installations",
    description:
      "Professional event branding including signage, graphics, printed materials, and custom visual elements.",
  },
  {
    id: "corporate-private",
    title: "Corporate & Private Events",
    description:
      "Refined event solutions for business gatherings, social celebrations, launches, and private occasions.",
  },
];

const Services = () => {
  return (
    <section className="services-page">
      <div className="services-container">
        <h2 className="services-title">Our Services</h2>

        <div className="services-grid">
          {servicesData.map((service) => (
            <div key={service.id} className="service-card">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;